export default "__VITE_ASSET__CueadgcH__"